import { Maybe } from '../types';
import { defer } from '../utils/defer';

const unavailableStoreError = () => new Error('store unavailable');

interface Store {
  getItem<T>(
    key: string
  ): Promise<Maybe<T>>;

  setItem<T>(
    key: string,
    value: T
  ): Promise<void>;

  removeItem(key: string): Promise<void>;
}

export default class StoreProxy implements Store {
  public store: Store | null = null;
  public setStore: (store: Store) => void;
  public ready: () => Promise<void>;

  constructor() {
    const deferred = defer<void>();

    this.ready = async () => {
      await deferred.promise;
    };

    this.setStore = store => {
      this.store = store;
      deferred.resolve();
    };
  }

  public getItem<T>(
    key: string,
  ): Promise<Maybe<T>> {
    if (this.store) {
      return this.store.getItem(key);
    }
    throw unavailableStoreError();
  }

  public async tryGetItem<T>(
    key: string,
  ): Promise<Maybe<T>> {
    try {
      return await this.getItem(key);
    } catch (e) {
      console.log('StoreProxy.tryGetItem:', e);
    }
    return Promise.resolve(undefined);
  }

  public async setItem<T>(
    key: string,
    value: T
  ): Promise<void> {
    if (this.store) {
      await this.store.setItem(key, value);
      return;
    }
    throw unavailableStoreError();
  }

  public async trySetItem<T>(
    key: string,
    value: T
  ): Promise<boolean> {
    try {
      await this.setItem(key, value);
      return true;
    } catch (e) {
      console.log('StoreProxy.trySetItem:', e);
      return false;
    }
  }

  public removeItem(key: string): Promise<void> {
    if (this.store) {
      return this.store.removeItem(key);
    }
    throw unavailableStoreError();
  }
}
